import {Component} from "react";
import "./assets/toolbox.css"
import ToolboxItem from "./ToolboxItem"
import Separator from "./Sparator"
import {ListUl, Cubes, Book} from 'styled-icons/fa-solid'
// import {Documents } from 'styled-icons/ionicons-solid'
import types from "../data/Types"
import {PersonCircle} from 'styled-icons/ionicons-outline'
import {Document} from 'styled-icons/fluentui-system-filled'
import {Favorite, MenuBook} from 'styled-icons/material'
import {Dice3Fill} from 'styled-icons/bootstrap'
import {Omega} from 'styled-icons/remix-editor'
import {NetworkChart} from 'styled-icons/boxicons-solid'
import {Books} from 'styled-icons/icomoon'
import {Quote} from 'styled-icons/entypo'
import {Menu, MenuItem} from "@mui/material";
import ToolboxItemInList from "./ToolboxItemInList";

class Toolbox extends Component {


    constructor(props) {
        super(props);

        this.state = {
            openMenu: false,
            anchorEl: null,
            mouseX : 0,
            mouseY : 0
        }
    }

    clickOnButton = (e) => {
        this.props.addElement(e)
    }


    showMenu = (e, elementid) => {
        this.setState({openMenu: true, anchorEl: document.getElementById(elementid)}, () => {
        })
    }
    handleCloseMenu = (e) => {

        this.setState({openMenu: false, anchorEl: null});
    }

    render() {
        let iconWidth = 22
        return (
            <div className={"toolbox_container"}>
                <div className={"toolbox_spacer"}/>
                <div className={"toolbox"}>

                    <ToolboxItem type={types.authors} icon={<PersonCircle width={iconWidth}/>} tooltip={"Authors"}
                                 onClick={(e) => {
                                     this.clickOnButton(e)
                                 }}/>
                    <ToolboxItem type={types.corpora} icon={<Books width={iconWidth}/>} tooltip={"Corpora"}
                                 onClick={(e) => {
                                     this.clickOnButton(e)
                                 }}/>
                    <ToolboxItem type={types.documents} icon={<Document width={iconWidth}/>} tooltip={"Documents"}
                                 onClick={(e) => {
                                     this.clickOnButton(e)
                                 }}/>
                    <ToolboxItem type={types.tokens} icon={<Quote width={iconWidth}/>} tooltip={"Tokens"}
                                 onClick={(e) => {
                                     this.clickOnButton(e)
                                 }}/>
                    <Separator/>
                    <ToolboxItem type={types.lemmabank} icon={<ListUl width={iconWidth}/>} tooltip={"Lemma Bank"}
                                 onClick={(e) => {
                                     this.clickOnButton(e)
                                 }}/>
                    <Separator/>
                    <ToolboxItem type={types.wfl} tooltip={"Word Formation Latin"} icon={<Cubes width={iconWidth}/>}
                                 onClick={(e) => {
                                     this.clickOnButton(e)
                                 }}/>
                    <ToolboxItem type={types.affectus} tooltip={"Latin Affectus"} icon={<Favorite width={iconWidth}/>}
                                 onClick={(e) => {
                                     this.clickOnButton(e)
                                 }}/>
                    <ToolboxItem type={types.wordnet} tooltip={"Latin Wordnet"} icon={<NetworkChart width={iconWidth}/>}
                                 onClick={(e) => {
                                     this.clickOnButton(e)
                                 }}/>
                    {/*<ToolboxItem type={types.igvll} tooltip={"Index Graecorum Vocabulorum"} icon={<Omega width={iconWidth}/>} onClick={(e) => {*/}
                    {/*    this.clickOnButton(e)*/}
                    {/*}}/>*/}
                    {/*<ToolboxItem type={types.brill} tooltip={"Brill"} icon={<MenuBook width={iconWidth}/>} onClick={(e) => {*/}
                    {/*    this.clickOnButton(e)*/}
                    {/*}}/>*/}
                    {/*<ToolboxItem type={types.ls} tooltip={"Lewis & Short"} icon={<Book width={iconWidth - 4}/>} onClick={(e) => {*/}
                    {/*    this.clickOnButton(e)*/}
                    {/*}}/>*/}

                    <ToolboxItem id={"dictionaryList"} aria-controls={this.state.openMenu ? 'basic-menu' : undefined} type={types.ls}
                                 tooltip={"Dictionaries"} icon={<Book width={iconWidth - 4}/>}
                                 onClick={(e) => {this.showMenu(e, "dictionaryList")}}
                    />


                    <ToolboxItem type={types.vallex} tooltip={"Vallex"} icon={<Dice3Fill width={iconWidth - 4}/>}
                                 onClick={(e) => {
                                     this.clickOnButton(e)
                                 }}/>


                    <Menu
                        id="basic-menu"
                        anchorEl={this.state.anchorEl}
                        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                        open={this.state.openMenu}
                        onClose={this.handleCloseMenu}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <MenuItem>
                            <ToolboxItemInList label={"English - Lewis & Short"} type={types.ls} tooltip={"Lewis & Short"} icon={<Book width={iconWidth - 4}/>}
                                         onClick={(e) => {
                                             this.clickOnButton(e)
                                         }}/>
                        </MenuItem>
                        <MenuItem>
                            <ToolboxItemInList label={"Portuguese - Velez"} type={types.velez} tooltip={"Portuguese - Velez"} icon={<Book width={iconWidth - 4}/>}
                                               onClick={(e) => {
                                                   this.clickOnButton(e)
                                               }}/>
                        </MenuItem>
                        <MenuItem>
                            <ToolboxItemInList label={"Portuguese - Cardoso"} type={types.cardoso} tooltip={"Portuguese - Cardoso"} icon={<Book width={iconWidth - 4}/>}
                                               onClick={(e) => {
                                                   this.clickOnButton(e)
                                               }}/>
                        </MenuItem>
                        <MenuItem>
                            <ToolboxItemInList label={"Portuguese - Fonseca"} type={types.fonseca} tooltip={"Portuguese - Fonseca"} icon={<Book width={iconWidth - 4}/>}
                                               onClick={(e) => {
                                                   this.clickOnButton(e)
                                               }}/>
                        </MenuItem>
                        <MenuItem>
                            <ToolboxItemInList label={"French - Lexicala"} type={types.lexicala} tooltip={"French - Lexicala"} icon={<Book width={iconWidth - 4}/>}
                                               onClick={(e) => {
                                                   this.clickOnButton(e)
                                               }}/>
                        </MenuItem>
                    </Menu>
                </div>
                <div className={"toolbox_spacer"}/>
            </div>
        )
    }

}

export default Toolbox
